import { gql } from '@apollo/client';

export const pageApplicationUsers = gql`
  query pageApplicationUsers($page: Int!, $amount: Int!, $field: String!, $sort: String!, $filters: [FilterInput!], $csv: Boolean!) {
    pageApplicationUsers(grid: { amount: $amount, page: $page, field: $field, filters: $filters, sort: $sort, csv: $csv }) {
      data {
        id
        active
        emailAddress
        name
        adId
      }
      count
    }
  }
`;
